import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {select, Store} from '@ngrx/store';
import {map, withLatestFrom} from 'rxjs/operators';
import {LoadPathwaysAction} from '@ispm-client/modules/pathways/store';
import {selectCurrentConfig} from '../../../../configuration/store/configuration.selector';
import {selectCurrentDiagnosticOrder} from '../../../../../app/dashboard/test/store/diagnostic-order.selector';
import {selectActiveWorkflow, selectRequestedRevision} from '../../../../../app/workflow-config/store/workflow-config.selectors';
import {pathwaysSelectionJobName} from '@ispm-client/modules/pathways/index';
import {PathwaysTrigger, PathwaysTriggerOff, PrefetchDataActionTypes} from '@ispm/test/store/prefetch-data/prefetch-data.actions';

@Injectable()
export class PrefetchDataEffects {

  constructor(private actions$: Actions,
              private store$: Store<any>) {
  }


  @Effect()
  pathwaysTriggerEffect$ = this.actions$.pipe(
    ofType<PathwaysTrigger>(PrefetchDataActionTypes.PATHWAYS_TRIGGER_ON),
    withLatestFrom(
      this.store$.pipe(select(selectCurrentDiagnosticOrder)),
      this.store$.pipe(select(selectCurrentConfig)),
      this.store$.pipe(select(selectActiveWorkflow)),
      this.store$.pipe(select(selectRequestedRevision))),
    map(([action, currentDiagnosticOrder, testConfiguration, activeWorkflow, requestedRevision]) => {
      let activeJobName;
      if (requestedRevision && requestedRevision.activeJobName) {
        activeJobName = requestedRevision.activeJobName;
      } else {
        if (activeWorkflow && activeWorkflow.activeJobName) {
          activeJobName = activeWorkflow.activeJobName;
        }
      }
      if (activeJobName && activeJobName === pathwaysSelectionJobName) {
        return new LoadPathwaysAction();
      } else {
        return new PathwaysTriggerOff();
      }
    })
  );


}



